// Mock data for Dezire Metal Roofing

export const businessInfo = {
  name: "Dezire Metal Roofing",
  phone: "0433973844",
  email: "Deziremetalroofing@gmail.com",
  address: {
    street: "Cecil Hills",
    suburb: "Cecil Hills",
    state: "NSW",
    postcode: "2171",
    full: "Cecil Hills, NSW 2171, Australia"
  },
  serviceArea: "Greater Sydney Area",
  hours: "24/7 Emergency Service"
};

export const services = [
  {
    id: 1,
    title: "Metal Roof Installation",
    description: "Professional metal roof installation services for homeowners across Greater Sydney. New builds, renovations, and upgrades with quality materials suited to Australian conditions.",
    icon: "home",
    features: ["New metal roof installation", "Re-roofing and upgrades", "Residential roofing solutions", "Flashings and finishing details"]
  },
  {
    id: 2,
    title: "Roof Repairs",
    description: "Prompt roof repair services to address leaks, damaged sheets, flashing issues, and general wear before they become costly repairs.",
    icon: "wrench",
    features: ["Roof leaks", "Loose or damaged roofing sheets", "Flashing issues", "Storm-related damage"]
  },
  {
    id: 3,
    title: "Roof Replacement",
    description: "Professional roof replacement services for roofs that are old, worn, rusted, or repeatedly causing problems. Upgrade to safer, stronger roofing.",
    icon: "refresh-cw",
    features: ["Full roof removal", "Structural assessment", "Quality metal roofing", "Improved appearance and value"]
  },
  {
    id: 4,
    title: "Gutter Installation",
    description: "Gutter installation and replacement services to protect your home from water damage. Improve drainage and reduce overflow risk.",
    icon: "shield-check",
    features: ["New gutter installation", "Gutter replacement", "Downpipe installation", "Gutter guard solutions"]
  }
];

export const specialDeals = [
  {
    id: 1,
    title: "$500 Referral Bonus",
    description: "Refer a friend or family member and receive $500 when they complete a full roof replacement with us.",
    value: "$500",
    savings: "$500 CASH",
    type: "referral",
    terms: "Bonus paid after successful completion of referral's full roof replacement project."
  },
  {
    id: 2,
    title: "Free Downpipe Replacements",
    description: "Replace your entire perimeter guttering and receive 2 free downpipe replacements absolutely free.",
    value: "$500+",
    savings: "SAVE $500+",
    type: "bundle",
    terms: "Offer valid with full perimeter gutter replacement. Value over $500."
  }
];

export const benefits = [
  {
    id: 1,
    title: "Superior Durability",
    description: "Metal roofs last 40-70 years, far outlasting traditional roofing materials.",
    icon: "shield"
  },
  {
    id: 2,
    title: "Energy Efficient",
    description: "Reflective properties reduce cooling costs by up to 25% in summer months.",
    icon: "zap"
  },
  {
    id: 3,
    title: "Weather Resistant",
    description: "Withstands extreme weather including heavy rain, hail, and strong winds.",
    icon: "cloud-rain"
  },
  {
    id: 4,
    title: "Eco-Friendly",
    description: "100% recyclable material that's environmentally sustainable.",
    icon: "leaf"
  },
  {
    id: 5,
    title: "Low Maintenance",
    description: "Requires minimal upkeep compared to traditional roofing options.",
    icon: "check-circle"
  },
  {
    id: 6,
    title: "Increases Property Value",
    description: "Boost your home's resale value with premium metal roofing.",
    icon: "trending-up"
  }
];

export const galleryImages = [
  // Original project photos (actual roofing work images)
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/g9jljj6s_13506d2d-2490-4647-bf63-c0b287e8cac5.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/xrhyyagc_108a57f6-f46e-4847-bad7-475dc554bbff.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/ntxm963s_2f605b35-ab24-4aae-ad1c-46803d3e8877.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/oei26rau_bb503543-bdc3-4a9b-9b8c-c511d3066285.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/i6j725gu_aea9cdf8-6263-4b59-b19f-8ed0193d2e8c.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/lhv6tn1c_aea9cdf8-6263-4b59-b19f-8ed0193d2e8c.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/zrqyrs2h_b1af1cf4-190b-4caf-945d-73d8591fc9b9.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/j60s3uy4_c558bb4d-3c48-4769-96cf-d1353d2bda6b.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/nbfl5j1i_7c9eabe2-4097-45c1-843e-16e3d3093f7c.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/bqktg9bw_18b8e293-a942-4090-b7ab-1595eb0f0314.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/8huukfis_6d5e74f0-1733-4d83-9224-112f58019b56.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/3q115e6l_6cbbb617-b347-487f-a8e4-460a83908520.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/l4q68s2z_634b8a9d-49c5-4cd3-9625-ef02cd6b35f4.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/zdqo2aru_466ea1c8-fd12-4ac5-a247-09e42f5b730c.jpeg",
  "https://customer-assets.emergentagent.com/job_roof-booking-hub/artifacts/lvkk2oy2_ce8414cf-ec15-420e-8632-5da1daa3c6d5.jpeg"
];

export const faqs = [
  {
    id: 1,
    question: "Do you provide free quotes?",
    answer: "Yes, we provide free inspections and quotes for homeowners across Greater Sydney."
  },
  {
    id: 2,
    question: "What areas do you service?",
    answer: "We service Greater Sydney and surrounding areas. Contact us to confirm availability in your suburb."
  },
  {
    id: 3,
    question: "Do you handle roof repairs and full replacements?",
    answer: "Yes, we provide both repair services and complete roof replacement solutions depending on the condition of the roof."
  },
  {
    id: 4,
    question: "How do I know if my roof needs repair or replacement?",
    answer: "That depends on the extent of the damage, age of the roof, and overall condition. We can inspect the roof and explain the most practical option."
  },
  {
    id: 5,
    question: "Do you also install gutters and downpipes?",
    answer: "Yes, we provide gutter installation, replacement, and related drainage services."
  },
  {
    id: 6,
    question: "What should I do if my roof is leaking?",
    answer: "If your roof is leaking, it is best to arrange an inspection as soon as possible so the problem does not worsen and cause further damage."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    location: "Parramatta",
    rating: 5,
    text: "Exceptional service from start to finish. The team was professional, efficient, and our new metal roof looks fantastic. Highly recommend!"
  },
  {
    id: 2,
    name: "David Chen",
    location: "North Sydney",
    rating: 5,
    text: "Best decision we made for our home. The metal roof has reduced our energy bills and the craftsmanship is top-notch. Great value for money."
  },
  {
    id: 3,
    name: "Emma Thompson",
    location: "Penrith",
    rating: 5,
    text: "Quick response for our emergency repair. They came out the same day and fixed the issue professionally. Couldn't ask for better service."
  }
];
